import axios from 'axios';
import { MODE_FORCED_EVENT, readStoredMode, writeStoredMode } from 'utils/mode';

const axiosServices = axios.create({
  baseURL: import.meta.env.VITE_APP_API_URL || 'http://localhost:8000/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// interceptor for http
axiosServices.interceptors.request.use(
  (config) => {
    const isAdmin = config.url?.includes('/admin/');
    const token = isAdmin ? localStorage.getItem('gpo_admin_token') : localStorage.getItem('gpo_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    // Modo selecionado no header do dashboard (Produção / Sandbox)
    if (!isAdmin) {
      const mode = readStoredMode();
      if (mode) {
        config.headers['X-Gpo-Mode'] = mode;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    // Conta não validada a pedir Produção: passa para Sandbox e repete o pedido uma vez
    if (
      error.response?.status === 403 &&
      error.response?.data?.code === 'account_not_verified' &&
      error.config &&
      !error.config._modeRetried
    ) {
      writeStoredMode('test');
      window.dispatchEvent(new CustomEvent(MODE_FORCED_EVENT, { detail: { message: error.response.data.message } }));
      error.config._modeRetried = true;
      error.config.headers['X-Gpo-Mode'] = 'test';
      return axiosServices.request(error.config);
    }

    if (error.response && error.response.status === 401) {
      const isAuthUrl = error.config?.url?.includes('/auth/login') || error.config?.url?.includes('/merchant');
      if (!isAuthUrl) {
        if (error.config?.url?.includes('/admin/')) {
          localStorage.removeItem('gpo_admin_token');
        } else {
          localStorage.removeItem('gpo_token');
        }
        window.location.href = '/login';
      }
    }

    const message =
      error.response?.data?.message ||
      (typeof error.response?.data === 'string' ? error.response.data : null) ||
      error.message ||
      'Erro na comunicação com o servidor';

    const customError = new Error(message);
    customError.response = error.response;
    customError.errors = error.response?.data?.errors;
    return Promise.reject(customError);
  }
);

export default axiosServices;
